module.exports = __webpack_public_path__ + "static/img/bottom_bg.b955f08.png";